(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["rl-buy-buttons"] && !Shopify.designMode) return;
  try {
    (function() {
  if (window.__rlBuyInit) return;
  window.__rlBuyInit = true;

  // Merkliste: Speichern übernimmt assets/rl-wishlist.js; hier nur der Hinweis-Toast
  var pendingWishlistBtn = null;

  document.addEventListener('click', function(e) {
    var btn = e.target.closest && e.target.closest('.rl-buy__save-btn');
    if (btn) pendingWishlistBtn = btn;
  }, true);

  window.addEventListener('rl:wishlist:updated', function() {
    var btn = pendingWishlistBtn;
    pendingWishlistBtn = null;
    if (!btn || !window.rlWishlist) return;
    if (window.rlWishlist.has(btn.dataset.productId)) {
      showToast('Auf der Merkliste gespeichert');
    } else {
      showToast('Von der Merkliste entfernt');
    }
  });

  // Ladezustand beim Hinzufügen (endet, sobald der Warenkorb geantwortet hat)
  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (!form || !form.closest || !form.closest('.rl-buy')) return;
    var btn = form.querySelector('.rl-buy__cart-btn');
    if (btn && !btn.disabled) {
      btn.classList.add('is-loading');
      setTimeout(function() { btn.classList.remove('is-loading'); }, 2000);
    }
  }, true);

  document.addEventListener('shopify:cart:lines-update', function(event) {
    if (event.action !== 'add' || !event.promise || !event.promise.finally) return;
    event.promise.finally(function() {
      document.querySelectorAll('.rl-buy__cart-btn.is-loading').forEach(function(btn) {
        btn.classList.remove('is-loading');
      });
    }).catch(function() {});
  });


  // Feste Kaufleiste: spiegelt Preis, Größe und Zustand des echten Kauf-Buttons
  function initSticky(bar) {
    if (bar.dataset.rlInit) return;
    bar.dataset.rlInit = '1';
    var buy = bar.previousElementSibling && bar.previousElementSibling.closest ? bar.parentElement : null;
    var main = (buy || document).querySelector('.rl-buy__cart-btn');
    var stickyBtn = bar.querySelector('[data-rl-sticky-btn]');
    var priceEl = bar.querySelector('[data-rl-sticky-price]');
    var sizeEl = bar.querySelector('[data-rl-sticky-size]');
    var headerPrice = document.getElementById('rl-price-' + bar.dataset.productId);
    if (!main || !stickyBtn) return;

    function sync() {
      stickyBtn.disabled = main.disabled;
      var label = main.querySelector('.rl-buy__cart-text');
      if (label) stickyBtn.textContent = label.textContent.trim();
      var cur = headerPrice && headerPrice.querySelector('.rl-price__current');
      if (cur && priceEl) priceEl.textContent = cur.textContent.trim();
      var size = document.querySelector('.rl-size-picker__selected');
      if (sizeEl) sizeEl.textContent = size ? size.textContent.trim() : '';
    }
    sync();
    new MutationObserver(sync).observe(main, { attributes: true, childList: true, subtree: true, characterData: true });
    if (headerPrice) new MutationObserver(sync).observe(headerPrice, { childList: true, subtree: true, characterData: true });
    document.addEventListener('rl:variant:changed', function () { setTimeout(sync, 0); });

    stickyBtn.addEventListener('click', function () {
      if (main.disabled) return;
      main.click();
    });

    function setVisible(v) {
      bar.classList.toggle('is-visible', v);
      bar.setAttribute('aria-hidden', v ? 'false' : 'true');
      stickyBtn.tabIndex = v ? 0 : -1;
      document.body.classList.toggle('rl-sticky-atc-on', v);
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          setVisible(!en.isIntersecting && en.boundingClientRect.top < 0);
        });
      }).observe(main);
    }
  }
  document.querySelectorAll('[data-rl-sticky-atc]').forEach(initSticky);

  // Toast notification
  function showToast(message) {
    // Remove existing toast
    var existing = document.querySelector('.rl-toast');
    if (existing) existing.remove();

    var toast = document.createElement('div');
    toast.className = 'rl-toast';
    toast.setAttribute('role', 'status');
    toast.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">' +
      '<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>' +
      '</svg>';
    var text = document.createElement('span');
    text.textContent = message;
    toast.appendChild(text);
    document.body.appendChild(toast);

    // Animate in
    requestAnimationFrame(function() {
      toast.classList.add('is-visible');
    });

    // Auto remove
    setTimeout(function() {
      toast.classList.remove('is-visible');
      setTimeout(function() { toast.remove(); }, 300);
    }, 2500);
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["rl-color-picker"] && !Shopify.designMode) return;
  try {
    (function() {
  // Store for current selected options per product
  window.rlSelectedOptions = window.rlSelectedOptions || {};

  function initColorPicker() {
    // Nur Varianten-Farbwahl (die Produktgruppen-Kacheln aus rl-product-group sind Links)
    const colorPickers = document.querySelectorAll('.rl-color-picker[data-option-index]');

    colorPickers.forEach(picker => {
      if (picker.dataset.rlInit) return;
      picker.dataset.rlInit = '1';

      const productId = picker.dataset.productId;
      const optionIndex = parseInt(picker.dataset.optionIndex);
      const buttons = picker.querySelectorAll('.rl-color-picker__btn');
      const selectedSpan = picker.querySelector('.rl-color-picker__selected');

      // Initialize selected options for this product
      if (!window.rlSelectedOptions[productId]) {
        window.rlSelectedOptions[productId] = {};
      }

      // Set initial value from active button
      const activeBtn = picker.querySelector('.rl-color-picker__btn.is-active');
      if (activeBtn) {
        window.rlSelectedOptions[productId][optionIndex] = activeBtn.dataset.optionValue;
      }

      buttons.forEach(btn => {
        btn.addEventListener('click', function() {
          if (this.disabled) return;

          const optionValue = this.dataset.optionValue;

          // Update active state
          buttons.forEach(b => b.classList.remove('is-active'));
          this.classList.add('is-active');

          // Update selected text
          if (selectedSpan) {
            selectedSpan.textContent = optionValue;
          }

          // Store selected option
          window.rlSelectedOptions[productId][optionIndex] = optionValue;

          // Find and update variant
          updateVariant(productId);
        });
      });
    });
  }

  function updateVariant(productId) {
    // Get variants data
    const variantsScript = document.querySelector(`script[data-rl-variants][data-product-id="${productId}"]`);
    if (!variantsScript) return;

    let variants;
    try {
      variants = JSON.parse(variantsScript.textContent);
    } catch(e) {
      console.error('Failed to parse variants', e);
      return;
    }

    // Get all selected options
    const selectedOptions = window.rlSelectedOptions[productId] || {};

    // Find matching variant
    const matchingVariant = variants.find(variant => {
      return variant.options.every((option, index) => {
        // If we have a selection for this option index, it must match
        if (selectedOptions[index] !== undefined) {
          return option === selectedOptions[index];
        }
        return true;
      });
    });

    if (matchingVariant) {
      // Update variant ID inputs in forms of the same product
      document.querySelectorAll('input[name="id"]').forEach(input => {
        const form = input.closest('form');
        if (!form) return;
        const owner = form.closest('[data-product-id]');
        if (owner && owner.dataset.productId === productId) {
          input.value = matchingVariant.id;
        }
      });

      // Update URL
      const url = new URL(window.location.href);
      url.searchParams.set('variant', matchingVariant.id);
      window.history.replaceState({}, '', url);

      // Dispatch custom event for other components
      document.dispatchEvent(new CustomEvent('rl:variant:changed', {
        detail: {
          productId: productId,
          variant: matchingVariant
        }
      }));

      // Update buy button availability
      updateBuyButton(matchingVariant, productId);
    }
  }

  function updateBuyButton(variant, productId) {
    const buyBtns = document.querySelectorAll(`.rl-buy[data-product-id="${productId}"] .rl-buy__cart-btn`);
    buyBtns.forEach(btn => {
      const textEl = btn.querySelector('.rl-buy__cart-text');
      if (variant.available) {
        btn.disabled = false;
        if (textEl) {
          textEl.textContent = btn.dataset.addText || 'In den Warenkorb';
        }
      } else {
        btn.disabled = true;
        if (textEl) {
          textEl.textContent = btn.dataset.soldText || 'Ausverkauft';
        }
      }
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initColorPicker);
  } else {
    initColorPicker();
  }
  document.addEventListener('shopify:section:load', initColorPicker);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["rl-product-details"] && !Shopify.designMode) return;
  try {
    (function() {
  // Accordion functionality (einmal global, funktioniert auch nach Neuladen im Editor)
  if (window.__rlProductDetailsInit) return;
  window.__rlProductDetailsInit = true;

  document.addEventListener('click', function(e) {
    const header = e.target.closest && e.target.closest('[data-rl-product-details] .rl-product-details__accordion-header');
    if (!header) return;

    const accordion = header.parentElement;
    const content = accordion.querySelector('.rl-product-details__accordion-content');
    const isOpen = accordion.classList.contains('is-open');

    if (isOpen) {
      // Close
      if (content.style.maxHeight === 'none' || content.style.maxHeight === '') {
        content.style.maxHeight = content.scrollHeight + 'px';
        content.offsetHeight; // Reflow, damit die Animation von der vollen Höhe startet
      }
      accordion.classList.remove('is-open');
      header.setAttribute('aria-expanded', 'false');
      content.style.maxHeight = '0px';
    } else {
      // Open
      accordion.classList.add('is-open');
      header.setAttribute('aria-expanded', 'true');
      content.style.maxHeight = content.scrollHeight + 'px';
    }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["rl-product-header"] && !Shopify.designMode) return;
  try {
    (function() {
  // Shopify-Money-Format-Platzhalter; bewusst zusammengesetzt, damit er nicht wie ein Liquid-Tag aussieht
  var DEFAULT_MONEY_FORMAT = '{' + '{amount}' + '} €';

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || DEFAULT_MONEY_FORMAT;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || '.';
      decimal = decimal || ',';

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    var match = formatString.match(placeholderRegex);
    if (!match) return formatString;

    switch (match[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  function initPriceUpdater() {
    document.addEventListener('rl:variant:changed', function(e) {
      var productId = e.detail.productId;
      var variant = e.detail.variant;

      var priceContainer = document.getElementById('rl-price-' + productId);
      var dataScript = document.getElementById('rl-product-data-' + productId);

      if (!priceContainer || !dataScript) return;

      var data;
      try {
        data = JSON.parse(dataScript.textContent);
      } catch(err) {
        return;
      }

      var moneyFormat = data.money_format || DEFAULT_MONEY_FORMAT;

      // Update price HTML
      var priceHtml = '<span class="rl-price__current" data-price="' + variant.price + '">' + formatMoney(variant.price, moneyFormat) + '</span>';

      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceHtml += '<span class="rl-price__compare" data-compare-price="' + variant.compare_at_price + '">' + formatMoney(variant.compare_at_price, moneyFormat) + '</span>';
      }

      priceContainer.innerHTML = priceHtml;

      // Rabatt-Badge (Prozent) aktualisieren
      var badge = document.getElementById('rl-badge-' + productId);
      if (badge) {
        var pct = (variant.compare_at_price && variant.compare_at_price > variant.price)
          ? Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price)
          : 0;
        var pctEl = badge.querySelector('[data-rl-badge-pct]');
        if (pctEl) pctEl.textContent = pct + ' %';
        badge.hidden = pct < 1;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPriceUpdater);
  } else {
    initPriceUpdater();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["rl-size-picker"] && !Shopify.designMode) return;
  try {
    (function() {
  // Store for current selected options per product
  window.rlSelectedOptions = window.rlSelectedOptions || {};

  function initSizePicker() {
    const sizePickers = document.querySelectorAll('.rl-size-picker');

    sizePickers.forEach(picker => {
      if (picker.dataset.rlInit) return;
      picker.dataset.rlInit = '1';

      const productId = picker.dataset.productId;
      const optionIndex = parseInt(picker.dataset.optionIndex);
      const buttons = picker.querySelectorAll('.rl-size-picker__btn');
      const selectedSpan = picker.querySelector('.rl-size-picker__selected');

      // Initialize selected options for this product
      if (!window.rlSelectedOptions[productId]) {
        window.rlSelectedOptions[productId] = {};
      }

      // Set initial value from active button
      const activeBtn = picker.querySelector('.rl-size-picker__btn.is-active');
      if (activeBtn) {
        window.rlSelectedOptions[productId][optionIndex] = activeBtn.dataset.optionValue;
      }

      buttons.forEach(btn => {
        btn.addEventListener('click', function() {
          if (this.disabled) return;

          const optionValue = this.dataset.optionValue;

          // Update active state
          buttons.forEach(b => b.classList.remove('is-active'));
          this.classList.add('is-active');

          // Update selected text
          if (selectedSpan) {
            selectedSpan.textContent = optionValue;
          }

          // Store selected option
          window.rlSelectedOptions[productId][optionIndex] = optionValue;

          // Find and update variant
          updateVariant(productId);
        });
      });
    });
  }

  function updateVariant(productId) {
    // Get variants data
    const variantsScript = document.querySelector(`script[data-rl-variants][data-product-id="${productId}"]`);
    if (!variantsScript) return;

    let variants;
    try {
      variants = JSON.parse(variantsScript.textContent);
    } catch(e) {
      console.error('Failed to parse variants', e);
      return;
    }

    // Get all selected options
    const selectedOptions = window.rlSelectedOptions[productId] || {};

    // Find matching variant
    const matchingVariant = variants.find(variant => {
      return variant.options.every((option, index) => {
        // If we have a selection for this option index, it must match
        if (selectedOptions[index] !== undefined) {
          return option === selectedOptions[index];
        }
        return true;
      });
    });

    if (matchingVariant) {
      // Update variant ID inputs in forms of the same product
      document.querySelectorAll('input[name="id"]').forEach(input => {
        const form = input.closest('form');
        if (!form) return;
        const owner = form.closest('[data-product-id]');
        if (owner && owner.dataset.productId === productId) {
          input.value = matchingVariant.id;
        }
      });

      // Update URL
      const url = new URL(window.location.href);
      url.searchParams.set('variant', matchingVariant.id);
      window.history.replaceState({}, '', url);

      // Dispatch custom event for other components
      document.dispatchEvent(new CustomEvent('rl:variant:changed', {
        detail: {
          productId: productId,
          variant: matchingVariant
        }
      }));

      // Update buy button availability
      updateBuyButton(matchingVariant, productId);
    }
  }

  function updateBuyButton(variant, productId) {
    const buyBtns = document.querySelectorAll(`.rl-buy[data-product-id="${productId}"] .rl-buy__cart-btn`);
    buyBtns.forEach(btn => {
      const textEl = btn.querySelector('.rl-buy__cart-text');
      if (variant.available) {
        btn.disabled = false;
        if (textEl) {
          textEl.textContent = btn.dataset.addText || 'In den Warenkorb';
        }
      } else {
        btn.disabled = true;
        if (textEl) {
          textEl.textContent = btn.dataset.soldText || 'Ausverkauft';
        }
      }
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSizePicker);
  } else {
    initSizePicker();
  }
  document.addEventListener('shopify:section:load', initSizePicker);
})();
  } catch(e) { console.error(e); }
})();

})();
